import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cb54a17c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: "assets/logo-light.png"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-light" }, "Empresa de Transporte y Mudanzas a nivel Local, Nacional e Internacional.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Información", -1))
const _hoisted_4 = { class: "enlaces" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Sobre Nosotros")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Contacto")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Aviso Legal")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Política de Privacidad")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Política de Cookies")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Contacto", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("639 97 70 27")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("info@mudanzascrespochiclana.es")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("C/ de las Tradiciones, 29, Nave 1, 11130 Chiclana de la Frontera, Cádiz")
const _hoisted_14 = { class: "container" }
const _hoisted_15 = { class: "copyright" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "poweredby" }, [
  /*#__PURE__*/_createTextVNode("Powered by "),
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Evolbe Systems")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_CookiesDialog = _resolveComponent("CookiesDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_footer, {
      class: "ion-no-border",
      id: "footer"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, { class: "container main-footer" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, {
                  size: "12",
                  "size-lg": "4",
                  class: "footer-widget"
                }, {
                  default: _withCtx(() => [
                    _hoisted_1,
                    _hoisted_2,
                    _createVNode(_component_ion_buttons, { style: {"margin-top":"2rem"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          fill: "outline",
                          color: "light",
                          style: {"--border-radius":"100%","width":"48px","height":"48px","margin-right":"1rem"},
                          href: "https://www.facebook.com/crespotransportes",
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              icon: _ctx.logoFacebook,
                              slot: "icon-only"
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_button, {
                          fill: "outline",
                          color: "light",
                          style: {"--border-radius":"100%","width":"48px","height":"48px","margin-right":"1rem"},
                          href: "https://www.instagram.com/mudanzascrespochiclana/",
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              icon: _ctx.logoInstagram,
                              slot: "icon-only"
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, {
                  size: "12",
                  "size-lg": "2"
                }),
                _createVNode(_component_ion_col, {
                  size: "12",
                  "size-lg": "2",
                  class: "footer-widget"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3,
                    _createElementVNode("ul", _hoisted_4, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, { to: "/sobre-nosotros" }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, { to: "/contacto" }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, { to: "/aviso-legal" }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, { to: "/privacidad" }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, { to: "/cookies" }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, {
                  size: "12",
                  "size-lg": "4",
                  class: "footer-widget"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    _createVNode(_component_ion_list, { lines: "none" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          button: "",
                          href: "tel:639977027"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              icon: _ctx.call,
                              color: "light",
                              slot: "start"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, {
                              "text-wrap": "",
                              color: "light"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, {
                          button: "",
                          href: "mailto:info@mudanzascrespochiclana.es"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              icon: _ctx.mail,
                              color: "light",
                              slot: "start"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, {
                              "text-wrap": "",
                              color: "light"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_12
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, {
                          button: "",
                          href: "https://goo.gl/maps/od63Pd2F5VC5wmT96",
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              icon: _ctx.location,
                              color: "light",
                              slot: "start"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, {
                              "text-wrap": "",
                              color: "light"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_13
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_grid, { class: "subfooter" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_ion_row, { class: "expanse" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "12",
                    "size-lg": "6"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_15, "© " + _toDisplayString(_ctx.anno) + " mudanzascrespochiclana.es", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    size: "12",
                    "size-lg": "6"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_CookiesDialog)
  ], 64))
}